const PFS_HIGH_RISK_DATA = [
  {
    t: 0.0,
    s: 1.0,
    lower: 1.0,
    upper: 1.0,
  },
  {
    t: 0.6,
    s: 0.9932432432,
    lower: 0.9530102093,
    upper: 0.9990454491,
  },
  {
    t: 0.7,
    s: 0.9864864865,
    lower: 0.9470513723,
    upper: 0.9966030774,
  },
  {
    t: 0.8,
    s: 0.972972973,
    lower: 0.9295968411,
    upper: 0.9897696803,
  },
  {
    t: 0.9,
    s: 0.9594594595,
    lower: 0.9119922846,
    upper: 0.9815800701,
  },
  {
    t: 1.0,
    s: 0.9459459459,
    lower: 0.8948242842,
    upper: 0.9725946577,
  },
  {
    t: 1.3,
    s: 0.9324324324,
    lower: 0.8780622704,
    upper: 0.9630626708,
  },
  {
    t: 1.4,
    s: 0.8378378378,
    lower: 0.7678909916,
    upper: 0.8882257933,
  },
  {
    t: 1.5,
    s: 0.7837837838,
    lower: 0.7083651704,
    upper: 0.8418646866,
  },
  {
    t: 1.6,
    s: 0.7364864865,
    lower: 0.6576101732,
    upper: 0.7999542389,
  },
  {
    t: 1.7,
    s: 0.7162162162,
    lower: 0.6361774544,
    upper: 0.7816729434,
  },
  {
    t: 1.8,
    s: 0.6959459459,
    lower: 0.6149185293,
    upper: 0.763218678,
  },
  {
    t: 1.9,
    s: 0.6689189189,
    lower: 0.5868275906,
    upper: 0.7383608262,
  },
  {
    t: 2.0,
    s: 0.6621621622,
    lower: 0.579848351,
    upper: 0.7321033521,
  },
  {
    t: 2.1,
    s: 0.6216216216,
    lower: 0.5383206614,
    upper: 0.694215849,
  },
  {
    t: 2.3,
    s: 0.6013513514,
    lower: 0.517772262,
    upper: 0.6750604623,
  },
  {
    t: 2.5,
    s: 0.5675675676,
    lower: 0.4838313514,
    upper: 0.6428350832,
  },
  {
    t: 2.6,
    s: 0.5540540541,
    lower: 0.4703599919,
    upper: 0.6298425201,
  },
  {
    t: 2.7,
    s: 0.5405405405,
    lower: 0.4569478064,
    upper: 0.6167923958,
  },
  {
    t: 2.8,
    s: 0.5131713992,
    lower: 0.4299076275,
    upper: 0.5902353278,
  },
  {
    t: 3.0,
    s: 0.5063291139,
    lower: 0.423186299,
    upper: 0.5835591291,
  },
  {
    t: 3.1,
    s: 0.4993930987,
    lower: 0.4163725924,
    upper: 0.576790427,
  },
  {
    t: 3.2,
    s: 0.4782919818,
    lower: 0.3956957044,
    upper: 0.5561470305,
  },
  {
    t: 3.3,
    s: 0.4360897481,
    lower: 0.3548145811,
    upper: 0.5144226329,
  },
  {
    t: 3.4,
    s: 0.4220223369,
    lower: 0.3413285234,
    upper: 0.5003836955,
  },
  {
    t: 3.5,
    s: 0.4149886313,
    lower: 0.3346122337,
    upper: 0.4933393887,
  },
  {
    t: 3.6,
    s: 0.4009212201,
    lower: 0.3212336417,
    upper: 0.4792006055,
  },
  {
    t: 3.7,
    s: 0.3868538088,
    lower: 0.3079278658,
    upper: 0.4649941366,
  },
  {
    t: 3.8,
    s: 0.3798201032,
    lower: 0.3013026481,
    upper: 0.4578651775,
  },
  {
    t: 4.0,
    s: 0.3587189864,
    lower: 0.2815397795,
    upper: 0.4363734449,
  },
  {
    t: 4.2,
    s: 0.3516852807,
    lower: 0.2749904284,
    upper: 0.4291739569,
  },
  {
    t: 4.3,
    s: 0.3446515751,
    lower: 0.2684605944,
    upper: 0.4219563297,
  },
  {
    t: 4.6,
    s: 0.3376178695,
    lower: 0.2619505338,
    upper: 0.4147203288,
  },
  {
    t: 4.8,
    s: 0.3235504583,
    lower: 0.2489908569,
    upper: 0.4001921777,
  },
  {
    t: 4.9,
    s: 0.3165167527,
    lower: 0.2425418564,
    upper: 0.3928994663,
  },
  {
    t: 5.0,
    s: 0.3094830471,
    lower: 0.2361138633,
    upper: 0.3855872559,
  },
  {
    t: 5.1,
    s: 0.2954156358,
    lower: 0.223322396,
    upper: 0.3709029787,
  },
  {
    t: 5.4,
    s: 0.2954156358,
    lower: 0.223322396,
    upper: 0.3709029787,
  },
  {
    t: 5.7,
    s: 0.2737998576,
    lower: 0.2037587122,
    upper: 0.3482716143,
  },
  {
    t: 5.8,
    s: 0.2665945982,
    lower: 0.1972891611,
    upper: 0.3406807435,
  },
  {
    t: 6.0,
    s: 0.2593893388,
    lower: 0.1908464075,
    upper: 0.3330654495,
  },
  {
    t: 6.1,
    s: 0.2377735605,
    lower: 0.171685657,
    upper: 0.310066878,
  },
  {
    t: 6.4,
    s: 0.2305683011,
    lower: 0.1653571029,
    upper: 0.30234749,
  },
  {
    t: 6.5,
    s: 0.2089525229,
    lower: 0.1465590258,
    upper: 0.2790183999,
  },
  {
    t: 6.7,
    s: 0.2017472635,
    lower: 0.1403590418,
    upper: 0.2711818872,
  },
  {
    t: 7.0,
    s: 0.1729262259,
    lower: 0.115923718,
    upper: 0.2395041395,
  },
  {
    t: 7.2,
    s: 0.1513104476,
    lower: 0.0980270304,
    upper: 0.2153555039,
  },
  {
    t: 7.3,
    s: 0.1441051882,
    lower: 0.0921545873,
    upper: 0.2072215793,
  },
  {
    t: 7.4,
    s: 0.1368999288,
    lower: 0.0863331757,
    upper: 0.1990414947,
  },
  {
    t: 7.5,
    s: 0.1296946694,
    lower: 0.080565994,
    upper: 0.1908124201,
  },
  {
    t: 7.6,
    s: 0.12248941,
    lower: 0.0748566735,
    upper: 0.1825311507,
  },
  {
    t: 7.7,
    s: 0.1152841506,
    lower: 0.0692093637,
    upper: 0.1741940349,
  },
  {
    t: 7.8,
    s: 0.1152841506,
    lower: 0.0692093637,
    upper: 0.1741940349,
  },
  {
    t: 8.1,
    s: 0.1075985405,
    lower: 0.0631654879,
    upper: 0.1653947675,
  },
  {
    t: 8.4,
    s: 0.0922273205,
    lower: 0.0513696199,
    upper: 0.1475409687,
  },
  {
    t: 8.5,
    s: 0.0845417104,
    lower: 0.0456357908,
    upper: 0.138470727,
  },
  {
    t: 8.6,
    s: 0.0768561004,
    lower: 0.0400267481,
    upper: 0.1292917559,
  },
  {
    t: 8.9,
    s: 0.0691704903,
    lower: 0.0345574491,
    upper: 0.1199914182,
  },
  {
    t: 9.1,
    s: 0.060524179,
    lower: 0.0283888306,
    upper: 0.1098571352,
  },
  {
    t: 9.5,
    s: 0.0518778678,
    lower: 0.0225154161,
    upper: 0.0994771386,
  },
  {
    t: 9.8,
    s: 0.0415022942,
    lower: 0.015542549,
    upper: 0.0879053633,
  },
  {
    t: 9.9,
    s: 0.0311267207,
    lower: 0.009432387,
    upper: 0.0756662661,
  },
  {
    t: 11.6,
    s: 0.0207511471,
    lower: 0.0044208141,
    upper: 0.0626683437,
  },
  {
    t: 15.1,
    s: 0.0103755736,
    lower: 0.0009820096,
    upper: 0.0491326148,
  },
  {
    t: 15.2,
    s: 0.0,
    lower: 0.0,
    upper: 0.0,
  },
];

export default PFS_HIGH_RISK_DATA;
